// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as CardValidations$OrcaPaymentPage from "./CardValidations.bs.js";

var invalidCPFs = [
  "00000000000",
  "11111111111",
  "22222222222",
  "33333333333",
  "44444444444",
  "55555555555",
  "66666666666",
  "77777777777",
  "88888888888",
  "99999999999"
];

function isValidCPFFormat(cpf) {
  if (/^\d*$/.test(cpf) && cpf.length === 11) {
    return !invalidCPFs.includes(cpf);
  } else {
    return false;
  }
}

function calculateCheckDigit(numbers) {
  var weight = numbers.length + 1 | 0;
  var sum = Core__Array.reduceWithIndex(numbers, 0, (function (acc, num, index) {
          return acc + Math.imul(num, weight - index | 0) | 0;
        }));
  var remainder = sum % 11;
  if (remainder < 2) {
    return 0;
  } else {
    return 11 - remainder | 0;
  }
}

function isValidCPF(cpf) {
  if (!isValidCPFFormat(cpf)) {
    return false;
  }
  var digits = cpf.split("").map(function (s) {
        return CardValidations$OrcaPaymentPage.toInt(s);
      });
  var baseCPF = digits.slice(0, 9);
  var firstDigit = calculateCheckDigit(baseCPF);
  var secondDigit = calculateCheckDigit(Belt_Array.concatMany([
            baseCPF,
            [firstDigit]
          ]));
  if (firstDigit === Core__Option.getOr(digits[9], -1)) {
    return secondDigit === Core__Option.getOr(digits[10], -1);
  } else {
    return false;
  }
}

var cpfLength = 11;

export {
  cpfLength ,
  invalidCPFs ,
  isValidCPFFormat ,
  calculateCheckDigit ,
  isValidCPF ,
}
/* No side effect */
